import { render } from "./ExternalLogin.vue?vue&type=template&id=3281d17a"
import script from "./ExternalLogin.vue?vue&type=script&lang=js"
export * from "./ExternalLogin.vue?vue&type=script&lang=js"

import "./ExternalLogin.vue?vue&type=style&index=0&id=3281d17a&lang=scss"

import exportComponent from "C:\\developmentGIT\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AccessIntegrationSite\\access-integration\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__